/**
 * Een klik of toets in een tabblad dat al open stond, opent oranje als er niets open staat (spec
 * 2026-10-24-urenregistratie, doel 3 en besluit 22). Zo krijgt wie na het automatisch uitklokken
 * doorwerkt weer een registratie, en blijft een vergeten tabblad dicht. De browser stuurt dan
 * `ONLINE_ACTIVITY_MESSAGE` over de websocket, hooguit eens per `ONLINE_ACTIVITY_MS`; de server laat
 * per verbinding ook niet vaker door.
 */
export const ONLINE_ACTIVITY_MESSAGE = 'active'
export const ONLINE_ACTIVITY_MS = 30_000

/** Geeft `true` bij de eerste aanroep en daarna pas weer als er `ms` voorbij is. */
export function activityGate(
  ms: number = ONLINE_ACTIVITY_MS,
  now: () => number = Date.now,
): () => boolean {
  let last = Number.NEGATIVE_INFINITY
  return () => {
    const t = now()
    if (t - last < ms) return false
    last = t
    return true
  }
}
